import React, { useState } from 'react';
import { marketingAPI } from '../services/api';
import './Marketing.css';

function BetaSignupForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    setError('');

    try {
      await marketingAPI.betaSignup({
        email: email.trim(),
        name: name.trim() || undefined,
        company: company.trim() || undefined,
        message: message.trim() || undefined,
        website,
      });
      setStatus('success');
      setEmail('');
      setName('');
      setCompany('');
      setMessage('');
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.message ||
        'Something went wrong. Please try again.';
      setError(msg);
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  if (status === 'success') {
    return (
      <div className="beta-form-message success" role="status">
        Thanks — we&apos;ll be in touch when beta access is available.
      </div>
    );
  }

  return (
    <form className="beta-form" onSubmit={handleSubmit} noValidate>
      {status === 'error' && error && (
        <div className="beta-form-message error" role="alert">
          {error}
        </div>
      )}

      <div className="beta-form-honeypot" aria-hidden="true">
        <label htmlFor="beta-website">Website</label>
        <input
          id="beta-website"
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
        />
      </div>

      <label htmlFor="beta-email">Email *</label>
      <input
        id="beta-email"
        type="email"
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <label htmlFor="beta-name">Name</label>
      <input
        id="beta-name"
        type="text"
        autoComplete="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <label htmlFor="beta-company">Company</label>
      <input
        id="beta-company"
        type="text"
        autoComplete="organization"
        value={company}
        onChange={(e) => setCompany(e.target.value)}
      />

      <label htmlFor="beta-message">Message</label>
      <textarea
        id="beta-message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Tell us about your content workflow (optional)"
      />

      <button type="submit" className="beta-form-submit" disabled={submitting}>
        {submitting ? 'Submitting…' : 'Request access'}
      </button>
    </form>
  );
}

export default BetaSignupForm;
